import { Outlet } from "react-router"
import Breadcrumbs from "./Breadcrumbs"
import useGenTest from "../../hooks/useGenTest"
import { __ } from "src/libs/utilities"
import { Button, Intent } from "@blueprintjs/core"
import { IPETest } from "../../data/interfaces"
import getDefaultTest from "../../data/mocks/getDefaultTest"
import { ITestsStore, useTestsStore } from "../../data/store"

const TestGenerator = ():JSX.Element => {
    const genTests: IPETest[] = useTestsStore((state: ITestsStore) => state.genTests) 
    const genTest = useGenTest()

    const onAddNewTest = () => {
        const newTest = getDefaultTest()
        const _tests: IPETest[] = [
            ...genTests, 
            newTest
        ]
        useTestsStore.setState({genTests: _tests, genCurrentID: newTest.id})
    }
    
    return !!genTest.id 
        ?
        <div className=" container d-flex h-100 ">
            <Breadcrumbs />
            <Outlet />
        </div> 
        :
        <div className=" container flex-column h-100 flex-centered">
            <div className="lead-md mb-3">
                {__("Choose Test for editing or")}
            </div> 
            <Button
                large
                intent={Intent.DANGER}
                onClick={onAddNewTest}
            >
                {__("Create new Test")}
            </Button>
        </div> 
} 

export default TestGenerator